import {mapObjIndexed} from 'ramda';

function createEntity(name, numeric, hex, desc) {
    return {
        name, // name is case sensitive
        numeric,
        hex: hex.toLowerCase(),
        desc,
    };
}

// Characters -> Html Entities are listed in https://www.freeformatter.com/html-entities.html

export const ascii = {
    [String.fromCharCode(32)]: createEntity(' ', '&#32;', '&#x20;', 'Space'),
    '!': createEntity('!', '&#33;', '&#x21;', 'Exclamation mark'),
    '"': createEntity('"', '&#34;', '&#x22;', 'Quotation mark'),
    '#': createEntity('#', '&#35;', '&#x23;', 'Number sign'),
    '$': createEntity('$', '&#36;', '&#x24;', 'Dollar sign'),
    '%': createEntity('%', '&#37;', '&#x25;', 'Percent sign'),
    '&': createEntity('&amp;', '&#38;', '&#x26;', 'Ampersand'),
    '\'': createEntity('\'', '&#39;', '&#x27;', 'Apostrophe'),
    '(': createEntity('(', '&#40;', '&#x28;', 'Opening/Left Parenthesis'),
    ')': createEntity(')', '&#41;', '&#x29;', 'Closing/Right Parenthesis'),
    '*': createEntity('*', '&#42;', '&#x2a;', 'Asterisk'),
    '+': createEntity('+', '&#43;', '&#x2b;', 'Plus sign'),
    ',': createEntity(',', '&#44;', '&#x2c;', 'Comma'),
    '-': createEntity('-', '&#45;', '&#x2d;', 'Hyphen'),
    '.': createEntity('.', '&#46;', '&#x2e;', 'Period'),
    '/': createEntity('/', '&#47;', '&#x2f;', 'Slash'),
    '0': createEntity('0', '&#48;', '&#x30;', 'Digit 0'),
    '1': createEntity('1', '&#49;', '&#x31;', 'Digit 1'),
    '2': createEntity('2', '&#50;', '&#x32;', 'Digit 2'),
    '3': createEntity('3', '&#51;', '&#x33;', 'Digit 3'),
    '4': createEntity('4', '&#52;', '&#x34;', 'Digit 4'),
    '5': createEntity('5', '&#53;', '&#x35;', 'Digit 5'),
    '6': createEntity('6', '&#54;', '&#x36;', 'Digit 6'),
    '7': createEntity('7', '&#55;', '&#x37;', 'Digit 7'),
    '8': createEntity('8', '&#56;', '&#x38;', 'Digit 8'),
    '9': createEntity('9', '&#57;', '&#x39;', 'Digit 9'),
    ':': createEntity(':', '&#58;', '&#x3a;', 'Colon'),
    ';': createEntity(';', '&#59;', '&#x3b;', 'Semicolon'),
    '<': createEntity('&lt;', '&#60;', '&#x3c;', 'Less-than'),
    '=': createEntity('=', '&#61;', '&#x3d;', 'Equals sign'),
    '>': createEntity('&gt;', '&#62;', '&#x3e;', 'Greater than'),
    '?': createEntity('?', '&#63;', '&#x3f;', 'Question mark'),
    '@': createEntity('@', '&#64;', '&#x40;', 'At sign'),
    'A': createEntity('A', '&#65;', '&#x41;', 'Uppercase A'),
    'B': createEntity('B', '&#66;', '&#x42;', 'Uppercase B'),
    'C': createEntity('C', '&#67;', '&#x43;', 'Uppercase C'),
    'D': createEntity('D', '&#68;', '&#x44;', 'Uppercase D'),
    'E': createEntity('E', '&#69;', '&#x45;', 'Uppercase E'),
    'F': createEntity('F', '&#70;', '&#x46;', 'Uppercase F'),
    'G': createEntity('G', '&#71;', '&#x47;', 'Uppercase G'),
    'H': createEntity('H', '&#72;', '&#x48;', 'Uppercase H'),
    'I': createEntity('I', '&#73;', '&#x49;', 'Uppercase I'),
    'J': createEntity('J', '&#74;', '&#x4a;', 'Uppercase J'),
    'K': createEntity('K', '&#75;', '&#x4b;', 'Uppercase K'),
    'L': createEntity('L', '&#76;', '&#x4c;', 'Uppercase L'),
    'M': createEntity('M', '&#77;', '&#x4d;', 'Uppercase M'),
    'N': createEntity('N', '&#78;', '&#x4e;', 'Uppercase N'),
    'O': createEntity('O', '&#79;', '&#x4f;', 'Uppercase O'),
    'P': createEntity('P', '&#80;', '&#x50;', 'Uppercase P'),
    'Q': createEntity('Q', '&#81;', '&#x51;', 'Uppercase Q'),
    'R': createEntity('R', '&#82;', '&#x52;', 'Uppercase R'),
    'S': createEntity('S', '&#83;', '&#x53;', 'Uppercase S'),
    'T': createEntity('T', '&#84;', '&#x54;', 'Uppercase T'),
    'U': createEntity('U', '&#85;', '&#x55;', 'Uppercase U'),
    'V': createEntity('V', '&#86;', '&#x56;', 'Uppercase V'),
    'W': createEntity('W', '&#87;', '&#x57;', 'Uppercase W'),
    'X': createEntity('X', '&#88;', '&#x58;', 'Uppercase X'),
    'Y': createEntity('Y', '&#89;', '&#x59;', 'Uppercase Y'),
    'Z': createEntity('Z', '&#90;', '&#x5a;', 'Uppercase Z'),
    '[': createEntity('[', '&#91;', '&#x5b;', 'Opening/Left square bracket'),
    '\\': createEntity('\\', '&#92;', '&#x5c;', 'Backslash'),
    ']': createEntity(']', '&#93;', '&#x5d;', 'Closing/Right square bracket'),
    '^': createEntity('^', '&#94;', '&#x5e;', 'Caret'),
    '_': createEntity('_', '&#95;', '&#x5f;', 'Underscore'),
    '`': createEntity('`', '&#96;', '&#x60;', 'Grave accent'),
    'a': createEntity('a', '&#97;', '&#x61;', 'Lowercase a'),
    'b': createEntity('b', '&#98;', '&#x62;', 'Lowercase b'),
    'c': createEntity('c', '&#99;', '&#x63;', 'Lowercase c'),
    'd': createEntity('d', '&#100;', '&#x64;', 'Lowercase d'),
    'e': createEntity('e', '&#101;', '&#x65;', 'Lowercase e'),
    'f': createEntity('f', '&#102;', '&#x66;', 'Lowercase f'),
    'g': createEntity('g', '&#103;', '&#x67;', 'Lowercase g'),
    'h': createEntity('h', '&#104;', '&#x68;', 'Lowercase h'),
    'i': createEntity('i', '&#105;', '&#x69;', 'Lowercase i'),
    'j': createEntity('j', '&#106;', '&#x6a;', 'Lowercase j'),
    'k': createEntity('k', '&#107;', '&#x6b;', 'Lowercase k'),
    'l': createEntity('l', '&#108;', '&#x6c;', 'Lowercase l'),
    'm': createEntity('m', '&#109;', '&#x6d;', 'Lowercase m'),
    'n': createEntity('n', '&#110;', '&#x6e;', 'Lowercase n'),
    'o': createEntity('o', '&#111;', '&#x6f;', 'Lowercase o'),
    'p': createEntity('p', '&#112;', '&#x70;', 'Lowercase p'),
    'q': createEntity('q', '&#113;', '&#x71;', 'Lowercase q'),
    'r': createEntity('r', '&#114;', '&#x72;', 'Lowercase r'),
    's': createEntity('s', '&#115;', '&#x73;', 'Lowercase s'),
    't': createEntity('t', '&#116;', '&#x74;', 'Lowercase t'),
    'u': createEntity('u', '&#117;', '&#x75;', 'Lowercase u'),
    'v': createEntity('v', '&#118;', '&#x76;', 'Lowercase v'),
    'w': createEntity('w', '&#119;', '&#x77;', 'Lowercase w'),
    'x': createEntity('x', '&#120;', '&#x78;', 'Lowercase x'),
    'y': createEntity('y', '&#121;', '&#x79;', 'Lowercase y'),
    'z': createEntity('z', '&#122;', '&#x7a;', 'Lowercase z'),
    '{': createEntity('{', '&#123;', '&#x7b;', 'Opening/Left curly brace'),
    '|': createEntity('|', '&#124;', '&#x7c;', 'Vertical bar'),
    '}': createEntity('}', '&#125;', '&#x7d;', 'Closing/Right curly brace'),
    '~': createEntity('~', '&#126;', '&#x7e;', 'Tilde'),
};

export const iso8859_1_characters = {
    'À': createEntity('&Agrave;', '&#192;', '&#xc0;', 'Capital a with grave accent'),
    'Á': createEntity('&Aacute;', '&#193;', '&#xc1;', 'Capital a with acute accent'),
    'Â': createEntity('&Acirc;', '&#194;', '&#xc2;', 'Capital a with circumflex accent'),
    'Ã': createEntity('&Atilde;', '&#195;', '&#xc3;', 'Capital a with tilde'),
    'Ä': createEntity('&Auml;', '&#196;', '&#xc4;', 'Capital a with umlaut'),
    'Å': createEntity('&Aring;', '&#197;', '&#xc5;', 'Capital a with ring'),
    'Æ': createEntity('&AElig;', '&#198;', '&#xc6;', 'Capital ae'),
    'Ç': createEntity('&Ccedil;', '&#199;', '&#xc7;', 'Capital c with cedilla'),
    'È': createEntity('&Egrave;', '&#200;', '&#xc8;', 'Capital e with grave accent'),
    'É': createEntity('&Eacute;', '&#201;', '&#xc9;', 'Capital e with acute accent'),
    'Ê': createEntity('&Ecirc;', '&#202;', '&#xca;', 'Capital e with circumflex accent'),
    'Ë': createEntity('&Euml;', '&#203;', '&#xcb;', 'Capital e with umlaut'),
    'Ì': createEntity('&Igrave;', '&#204;', '&#xcc;', 'Capital i with grave accent'),
    'Í': createEntity('&Iacute;', '&#205;', '&#xcd;', 'Capital i with accute accent'),
    'Î': createEntity('&Icirc;', '&#206;', '&#xce;', 'Capital i with circumflex accent'),
    'Ï': createEntity('&Iuml;', '&#207;', '&#xcf;', 'Capital i with umlaut'),
    'Ð': createEntity('&ETH;', '&#208;', '&#xd0;', 'Capital eth (Icelandic)'),
    'Ñ': createEntity('&Ntilde;', '&#209;', '&#xd1;', 'Capital n with tilde'),
    'Ò': createEntity('&Ograve;', '&#210;', '&#xd2;', 'Capital o with grave accent'),
    'Ó': createEntity('&Oacute;', '&#211;', '&#xd3;', 'Capital o with accute accent'),
    'Ô': createEntity('&Ocirc;', '&#212;', '&#xd4;', 'Capital o with circumflex accent'),
    'Õ': createEntity('&Otilde;', '&#213;', '&#xd5;', 'Capital o with tilde'),
    'Ö': createEntity('&Ouml;', '&#214;', '&#xd6;', 'Capital o with umlaut'),
    'Ø': createEntity('&Oslash;', '&#216;', '&#xd8;', 'Capital o with slash'),
    'Ù': createEntity('&Ugrave;', '&#217;', '&#xd9;', 'Capital u with grave accent'),
    'Ú': createEntity('&Uacute;', '&#218;', '&#xda;', 'Capital u with acute accent'),
    'Û': createEntity('&Ucirc;', '&#219;', '&#xdb;', 'Capital u with circumflex accent'),
    'Ü': createEntity('&Uuml;', '&#220;', '&#xdc;', 'Capital u with umlaut'),
    'Ý': createEntity('&Yacute;', '&#221;', '&#xdd;', 'Capital y with acute accent'),
    'Þ': createEntity('&THORN;', '&#222;', '&#xde;', 'Capital thorn (Icelandic)'),
    'ß': createEntity('&szlig;', '&#223;', '&#xdf;', 'Lowercase sharp s (German)'),
    'à': createEntity('&agrave;', '&#224;', '&#xe0;', 'Lowercase a with grave accent'),
    'á': createEntity('&aacute;', '&#225;', '&#xe1;', 'Lowercase a with acute accent'),
    'â': createEntity('&acirc;', '&#226;', '&#xe2;', 'Lowercase a with circumflex accent'),
    'ã': createEntity('&atilde;', '&#227;', '&#xe3;', 'Lowercase a with tilde'),
    'ä': createEntity('&auml;', '&#228;', '&#xe4;', 'Lowercase a with umlaut'),
    'å': createEntity('&aring;', '&#229;', '&#xe5;', 'Lowercase a with ring'),
    'æ': createEntity('&aelig;', '&#230;', '&#xe6;', 'Lowercase ae'),
    'ç': createEntity('&ccedil;', '&#231;', '&#xe7;', 'Lowercase c with cedilla'),
    'è': createEntity('&egrave;', '&#232;', '&#xe8;', 'Lowercase e with grave accent'),
    'é': createEntity('&eacute;', '&#233;', '&#xe9;', 'Lowercase e with acute accent'),
    'ê': createEntity('&ecirc;', '&#234;', '&#xea;', 'Lowercase e with circumflex accent'),
    'ë': createEntity('&euml;', '&#235;', '&#xeb;', 'Lowercase e with umlaut'),
    'ì': createEntity('&igrave;', '&#236;', '&#xec;', 'Lowercase i with grave accent'),
    'í': createEntity('&iacute;', '&#237;', '&#xed;', 'Lowercase i with acute accent'),
    'î': createEntity('&icirc;', '&#238;', '&#xee;', 'Lowercase i with circumflex accent'),
    'ï': createEntity('&iuml;', '&#239;', '&#xef;', 'Lowercase i with umlaut'),
    'ð': createEntity('&eth;', '&#240;', '&#xf0;', 'Lowercase eth (Icelandic)'),
    'ñ': createEntity('&ntilde;', '&#241;', '&#xf1;', 'Lowercase n with tilde'),
    'ò': createEntity('&ograve;', '&#242;', '&#xf2;', 'Lowercase o with grave accent'),
    'ó': createEntity('&oacute;', '&#243;', '&#xf3;', 'Lowercase o with acute accent'),
    'ô': createEntity('&ocirc;', '&#244;', '&#xf4;', 'Lowercase o with circumflex accent'),
    'õ': createEntity('&otilde;', '&#245;', '&#xf5;', 'Lowercase o with tilde'),
    'ö': createEntity('&ouml;', '&#246;', '&#xf6;', 'Lowercase o with umlaut'),
    'ø': createEntity('&oslash;', '&#248;', '&#xf8;', 'Lowercase o with slash'),
    'ù': createEntity('&ugrave;', '&#249;', '&#xf9;', 'Lowercase u with grave accent'),
    'ú': createEntity('&uacute;', '&#250;', '&#xfa;', 'Lowercase u with acute accent'),
    'û': createEntity('&ucirc;', '&#251;', '&#xfb;', 'Lowercase u with circumflex accent'),
    'ü': createEntity('&uuml;', '&#252;', '&#xfc;', 'Lowercase u with umlaut'),
    'ý': createEntity('&yacute;', '&#253;', '&#xfd;', 'Lowercase y with acute accent'),
    'þ': createEntity('&thorn;', '&#254;', '&#xfe;', 'Lowercase thorn (Icelandic)'),
    'ÿ': createEntity('&yuml;', '&#255;', '&#xff;', 'Lowercase y with umlaut'),
};

export const iso8859_1_symbols = {
    // SLUI-305, commented out because whitespace html entities causes random { } when loaded through sinclair markdown
    // [String.fromCharCode(160)]: createEntity('&nbsp;', '&#160;', '&#xa0;', 'Non-breaking space'),
    '¡': createEntity('&iexcl;', '&#161;', '&#xa1;', 'Inverted exclamation mark'),
    '¢': createEntity('&cent;', '&#162;', '&#xa2;', 'Cent'),
    '£': createEntity('&pound;', '&#163;', '&#xa3;', 'Pound'),
    '¤': createEntity('&curren;', '&#164;', '&#xa4;', 'Currency'),
    '¥': createEntity('&yen;', '&#165;', '&#xa5;', 'Yen'),
    '¦': createEntity('&brvbar;', '&#166;', '&#xa6;', 'Broken vertical bar'),
    '§': createEntity('&sect;', '&#167;', '&#xa7;', 'Section'),
    '¨': createEntity('&uml;', '&#168;', '&#xa8;', 'Spacing diaeresis'),
    '©': createEntity('&copy;', '&#169;', '&#xa9;', 'Copyright'),
    'ª': createEntity('&ordf;', '&#170;', '&#xaa;', 'Feminine ordinal indicator'),
    '«': createEntity('&laquo;', '&#171;', '&#xab;', 'Opening/Left angle quotation mark'),
    '¬': createEntity('&not;', '&#172;', '&#xac;', 'Negation'),
    '­': createEntity('&shy;', '&#173;', '&#xad;', 'Soft hyphen'),
    '®': createEntity('&reg;', '&#174;', '&#xae;', 'Registered trademark'),
    '¯': createEntity('&macr;', '&#175;', '&#xaf;', 'Spacing macron'),
    '°': createEntity('&deg;', '&#176;', '&#xb0;', 'Degree'),
    '±': createEntity('&plusmn;', '&#177;', '&#xb1;', 'Plus or minus'),
    '²': createEntity('&sup2;', '&#178;', '&#xb2;', 'Superscript 2'),
    '³': createEntity('&sup3;', '&#179;', '&#xb3;', 'Superscript 3'),
    '´': createEntity('&acute;', '&#180;', '&#xb4;', 'Spacing acute'),
    'µ': createEntity('&micro;', '&#181;', '&#xb5;', 'Micro'),
    '¶': createEntity('&para;', '&#182;', '&#xb6;', 'Paragraph'),
    '¸': createEntity('&cedil;', '&#184;', '&#xb8;', 'Spacing cedilla'),
    '¹': createEntity('&sup1;', '&#185;', '&#xb9;', 'Superscript 1'),
    'º': createEntity('&ordm;', '&#186;', '&#xba;', 'Masculine ordinal indicator'),
    '»': createEntity('&raquo;', '&#187;', '&#xbb;', 'Closing/Right angle quotation mark'),
    '¼': createEntity('&frac14;', '&#188;', '&#xbc;', 'Fraction 1/4'),
    '½': createEntity('&frac12;', '&#189;', '&#xbd;', 'Fraction 1/2'),
    '¾': createEntity('&frac34;', '&#190;', '&#xbe;', 'Fraction 3/4'),
    '¿': createEntity('&iquest;', '&#191;', '&#xbf;', 'Inverted question mark'),
    '×': createEntity('&times;', '&#215;', '&#xd7;', 'Multiplication'),
    '÷': createEntity('&divide;', '&#247;', '&#xf7;', 'Divide'),
};

export const mathSymbols = {
    '∀': createEntity('&forall;', '&#8704;', '&#x2200;', 'For all'),
    '∂': createEntity('&part;', '&#8706;', '&#x2202;', 'Part'),
    '∃': createEntity('&exist;', '&#8707;', '&#x2203;', 'Exist'),
    '∅': createEntity('&empty;', '&#8709;', '&#x2205;', 'Empty'),
    '∇': createEntity('&nabla;', '&#8711;', '&#x2207;', 'Nabla'),
    '∈': createEntity('&isin;', '&#8712;', '&#x2208;', 'Is in'),
    '∉': createEntity('&notin;', '&#8713;', '&#x2209;', 'Not in'),
    '∋': createEntity('&ni;', '&#8715;', '&#x220b;', 'Ni'),
    '∏': createEntity('&prod;', '&#8719;', '&#x220f;', 'Product'),
    '∑': createEntity('&sum;', '&#8721;', '&#x2211;', 'Sum'),
    '−': createEntity('&minus;', '&#8722;', '&#x2212;', 'Minus'),
    '∗': createEntity('&lowast;', '&#8727;', '&#x2217;', 'Asterisk (Lowast)'),
    '√': createEntity('&radic;', '&#8730;', '&#x221a;', 'Square root'),
    '∝': createEntity('&prop;', '&#8733;', '&#x221d;', 'Proportional to'),
    '∞': createEntity('&infin;', '&#8734;', '&#x221e;', 'Infinity'),
    '∠': createEntity('&ang;', '&#8736;', '&#x2220;', 'Angle'),
    '∧': createEntity('&and;', '&#8743;', '&#x2227;', 'And'),
    '∨': createEntity('&or;', '&#8744;', '&#x2228;', 'Or'),
    '∩': createEntity('&cap;', '&#8745;', '&#x2229;', 'Cap'),
    '∪': createEntity('&cup;', '&#8746;', '&#x222a;', 'Cup'),
    '∫': createEntity('&int;', '&#8747;', '&#x222b;', 'Integral'),
    '∴': createEntity('&there4;', '&#8756;', '&#x2234;', 'Therefore'),
    '∼': createEntity('&sim;', '&#8764;', '&#x223c;', 'Similar to'),
    '≅': createEntity('&cong;', '&#8773;', '&#x2245;', 'Congurent to'),
    '≈': createEntity('&asymp;', '&#8776;', '&#x2248;', 'Almost equal'),
    '≠': createEntity('&ne;', '&#8800;', '&#x2260;', 'Not equal'),
    '≡': createEntity('&equiv;', '&#8801;', '&#x2261;', 'Equivalent'),
    '≤': createEntity('&le;', '&#8804;', '&#x2264;', 'Less or equal'),
    '≥': createEntity('&ge;', '&#8805;', '&#x2265;', 'Greater or equal'),
    '⊂': createEntity('&sub;', '&#8834;', '&#x2282;', 'Subset of'),
    '⊃': createEntity('&sup;', '&#8835;', '&#x2283;', 'Superset of'),
    '⊄': createEntity('&nsub;', '&#8836;', '&#x2284;', 'Not subset of'),
    '⊆': createEntity('&sube;', '&#8838;', '&#x2286;', 'Subset or equal'),
    '⊇': createEntity('&supe;', '&#8839;', '&#x2287;', 'Superset or equal'),
    '⊕': createEntity('&oplus;', '&#8853;', '&#x2295;', 'Circled plus'),
    '⊗': createEntity('&otimes;', '&#8855;', '&#x2297;', 'Circled times'),
    '⊥': createEntity('&perp;', '&#8869;', '&#x22a5;', 'Perpendicular'),
    '⋅': createEntity('&sdot;', '&#8901;', '&#x22c5;', 'Dot operator'),
};

export const greekLetters = {
    'Α': createEntity('&Alpha;', '&#913;', '&#x391;', 'Alpha'),
    'Β': createEntity('&Beta;', '&#914;', '&#x392;', 'Beta'),
    'Γ': createEntity('&Gamma;', '&#915;', '&#x393;', 'Gamma'),
    'Δ': createEntity('&Delta;', '&#916;', '&#x394;', 'Delta'),
    'Ε': createEntity('&Epsilon;', '&#917;', '&#x395;', 'Epsilon'),
    'Ζ': createEntity('&Zeta;', '&#918;', '&#x396;', 'Zeta'),
    'Η': createEntity('&Eta;', '&#919;', '&#x397;', 'Eta'),
    'Θ': createEntity('&Theta;', '&#920;', '&#x398;', 'Theta'),
    'Ι': createEntity('&Iota;', '&#921;', '&#x399;', 'Iota'),
    'Κ': createEntity('&Kappa;', '&#922;', '&#x39a;', 'Kappa'),
    'Λ': createEntity('&Lambda;', '&#923;', '&#x39b;', 'Lambda'),
    'Μ': createEntity('&Mu;', '&#924;', '&#x39c;', 'Mu'),
    'Ν': createEntity('&Nu;', '&#925;', '&#x39d;', 'Nu'),
    'Ξ': createEntity('&Xi;', '&#926;', '&#x39e;', 'Xi'),
    'Ο': createEntity('&Omicron;', '&#927;', '&#x39f;', 'Omicron'),
    'Π': createEntity('&Pi;', '&#928;', '&#x3a0;', 'Pi'),
    'Ρ': createEntity('&Rho;', '&#929;', '&#x3a1;', 'Rho'),
    'Σ': createEntity('&Sigma;', '&#931;', '&#x3a3;', 'Sigma'),
    'Τ': createEntity('&Tau;', '&#932;', '&#x3a4;', 'Tau'),
    'Υ': createEntity('&Upsilon;', '&#933;', '&#x3a5;', 'Upsilon'),
    'Φ': createEntity('&Phi;', '&#934;', '&#x3a6;', 'Phi'),
    'Χ': createEntity('&Chi;', '&#935;', '&#x3a7;', 'Chi'),
    'Ψ': createEntity('&Psi;', '&#936;', '&#x3a8;', 'Psi'),
    'Ω': createEntity('&Omega;', '&#937;', '&#x3a9;', 'Omega'),
    'α': createEntity('&alpha;', '&#945;', '&#x3b1;', 'alpha'),
    'β': createEntity('&beta;', '&#946;', '&#x3b2;', 'beta'),
    'γ': createEntity('&gamma;', '&#947;', '&#x3b3;', 'gamma'),
    'δ': createEntity('&delta;', '&#948;', '&#x3b4;', 'delta'),
    'ε': createEntity('&epsilon;', '&#949;', '&#x3b5;', 'epsilon'),
    'ζ': createEntity('&zeta;', '&#950;', '&#x3b6;', 'zeta'),
    'η': createEntity('&eta;', '&#951;', '&#x3b7;', 'eta'),
    'θ': createEntity('&theta;', '&#952;', '&#x3b8;', 'theta'),
    'ι': createEntity('&iota;', '&#953;', '&#x3b9;', 'iota'),
    'κ': createEntity('&kappa;', '&#954;', '&#x3ba;', 'kappa'),
    'λ': createEntity('&lambda;', '&#955;', '&#x3bb;', 'lambda'),
    'μ': createEntity('&mu;', '&#956;', '&#x3bc;', 'mu'),
    'ν': createEntity('&nu;', '&#957;', '&#x3bd;', 'nu'),
    'ξ': createEntity('&xi;', '&#958;', '&#x3be;', 'xi'),
    'ο': createEntity('&omicron;', '&#959;', '&#x3bf;', 'omicron'),
    'π': createEntity('&pi;', '&#960;', '&#x3c0;', 'pi'),
    'ρ': createEntity('&rho;', '&#961;', '&#x3c1;', 'rho'),
    'ς': createEntity('&sigmaf;', '&#962;', '&#x3c2;', 'sigmaf'),
    'σ': createEntity('&sigma;', '&#963;', '&#x3c3;', 'sigma'),
    'τ': createEntity('&tau;', '&#964;', '&#x3c4;', 'tau'),
    'υ': createEntity('&upsilon;', '&#965;', '&#x3c5;', 'upsilon'),
    'φ': createEntity('&phi;', '&#966;', '&#x3c6;', 'phi'),
    'χ': createEntity('&chi;', '&#967;', '&#x3c7;', 'chi'),
    'ψ': createEntity('&psi;', '&#968;', '&#x3c8;', 'psi'),
    'ω': createEntity('&omega;', '&#969;', '&#x3c9;', 'omega'),
    'ϑ': createEntity('&thetasym;', '&#977;', '&#x3d1;', 'Theta symbol'),
    'ϒ': createEntity('&upsih;', '&#978;', '&#x3d2;', 'Upsilon symbol'),
    'ϖ': createEntity('&piv;', '&#982;', '&#x3d6;', 'Pi symbol'),
};

export const misc = {
    'Œ': createEntity('&OElig;', '&#338;', '&#x152;', 'Uppercase ligature OE'),
    'œ': createEntity('&oelig;', '&#339;', '&#x153;', 'Lowercase ligature OE'),
    'Š': createEntity('&Scaron;', '&#352;', '&#x160;', 'Uppercase S with caron'),
    'š': createEntity('&scaron;', '&#353;', '&#x161;', 'Lowercase S with caron'),
    'Ÿ': createEntity('&Yuml;', '&#376;', '&#x178;', 'Capital Y with diaeres'),
    'ƒ': createEntity('&fnof;', '&#402;', '&#x192;', 'Lowercase with hook'),
    'ˆ': createEntity('&circ;', '&#710;', '&#x2c6;', 'Circumflex accent'),
    '˜': createEntity('&tilde;', '&#732;', '&#x2dc;', 'Tilde'),
    // SLUI-305, commented out because whitespace html entities causes random { } when loaded through sinclair markdown
    // [String.fromCharCode(8194)]: createEntity('&ensp;', '&#8194;', '&#x2002;', 'En space'),
    // [String.fromCharCode(8195)]: createEntity('&emsp;', '&#8195;', '&#x2003;', 'Em space'),
    // [String.fromCharCode(8201)]: createEntity('&thinsp;', '&#8201;', '&#x2009;', 'Thin space'),
    // [String.fromCharCode(8204)]: createEntity('&zwnj;', '&#8204;', '&#x200c;', 'Zero width non-joiner'),
    // [String.fromCharCode(8205)]: createEntity('&zwj;', '&#8205;', '&#x200d;', 'Zero width joiner'),
    // [String.fromCharCode(8206)]: createEntity('&lrm;', '&#8206;', '&#x200e;', 'Left-to-right mark'),
    // [String.fromCharCode(8207)]: createEntity('&rlm;', '&#8207;', '&#x200f;', 'Right-to-left mark'),
    '–': createEntity('&ndash;', '&#8211;', '&#x2013;', 'En dash'),
    '—': createEntity('&mdash;', '&#8212;', '&#x2014;', 'Em dash'),
    '‘': createEntity('&lsquo;', '&#8216;', '&#x2018;', 'Left single quotation mark'),
    '’': createEntity('&rsquo;', '&#8217;', '&#x2019;', 'Right single quotation mark'),
    '‚': createEntity('&sbquo;', '&#8218;', '&#x201a;', 'Single low-9 quotation mark'),
    '“': createEntity('&ldquo;', '&#8220;', '&#x201c;', 'Left double quotation mark'),
    '”': createEntity('&rdquo;', '&#8221;', '&#x201d;', 'Right double quotation mark'),
    '„': createEntity('&bdquo;', '&#8222;', '&#x201e;', 'Double low-9 quotation mark'),
    '†': createEntity('&dagger;', '&#8224;', '&#x2020;', 'Dagger'),
    '‡': createEntity('&Dagger;', '&#8225;', '&#x2021;', 'Double dagger'),
    '•': createEntity('&bull;', '&#8226;', '&#x2022;', 'Bullet'),
    '…': createEntity('&hellip;', '&#8230;', '&#x2026;', 'Horizontal ellipsis'),
    '‰': createEntity('&permil;', '&#8240;', '&#x2030;', 'Per mille'),
    '′': createEntity('&prime;', '&#8242;', '&#x2032;', 'Minutes (Degrees)'),
    '″': createEntity('&Prime;', '&#8243;', '&#x2033;', 'Seconds (Degrees)'),
    '‹': createEntity('&lsaquo;', '&#8249;', '&#x2039;', 'Single left angle quotation'),
    '›': createEntity('&rsaquo;', '&#8250;', '&#x203a;', 'Single right angle quotation'),
    '‾': createEntity('&oline;', '&#8254;', '&#x203e;', 'Overline'),
    '€': createEntity('&euro;', '&#8364;', '&#x20ac;', 'Euro'),
    '™': createEntity('&trade;', '&#8482;', '&#x2122;', 'Trademark'),
    '←': createEntity('&larr;', '&#8592;', '&#x2190;', 'Left arrow'),
    '↑': createEntity('&uarr;', '&#8593;', '&#x2191;', 'Up arrow'),
    '→': createEntity('&rarr;', '&#8594;', '&#x2192;', 'Right arrow'),
    '↓': createEntity('&darr;', '&#8595;', '&#x2193;', 'Down arrow'),
    '↔': createEntity('&harr;', '&#8596;', '&#x2194;', 'Left right arrow'),
    '↵': createEntity('&crarr;', '&#8629;', '&#x21b5;', 'Carriage return arrow'),
    '⌈': createEntity('&lceil;', '&#8968;', '&#x2308;', 'Left ceiling'),
    '⌉': createEntity('&rceil;', '&#8969;', '&#x2309;', 'Right ceiling'),
    '⌊': createEntity('&lfloor;', '&#8970;', '&#x230a;', 'Left floor'),
    '⌋': createEntity('&rfloor;', '&#8971;', '&#x230b;', 'Right floor'),
    '◊': createEntity('&loz;', '&#9674;', '&#x25ca;', 'Lozenge'),
    '♠': createEntity('&spades;', '&#9824;', '&#x2660;', 'Spade'),
    '♣': createEntity('&clubs;', '&#9827;', '&#x2663;', 'Club'),
    '♥': createEntity('&hearts;', '&#9829;', '&#x2665;', 'Heart'),
    '♦': createEntity('&diams;', '&#9830;', '&#x2666;', 'Diamond'),
};

const all = {
    ...iso8859_1_characters,
    ...iso8859_1_symbols,
    ...mathSymbols,
    ...greekLetters,
    ...misc,
    ...ascii,
};

export const dictUtf8ToHtmlEntities = mapObjIndexed((value, key) => value.name || key)(all);

export const whiteSpaceEntities = [
    '&nbsp;', '&#160;', '&#xa0;', 'Non-breaking space',
    '&ensp;', '&#8194;', '&#x2002;', 'En space',
    '&emsp;', '&#8195;', '&#x2003;', 'Em space',
    '&thinsp;', '&#8201;', '&#x2009;', 'Thin space',
    '&zwnj;', '&#8204;', '&#x200c;', 'Zero width non-joiner',
    '&zwj;', '&#8205;', '&#x200d;', 'Zero width joiner',
    '&lrm;', '&#8206;', '&#x200e;', 'Left-to-right mark',
    '&rlm;', '&#8207;', '&#x200f;', 'Right-to-left mark',
];

export const dictHtmlEntitiesToUtf8 =
    Object.fromEntries([
        ...Object.entries(all).map(
            ([key, value]) => [value.name, key]
        ),
        ...Object.entries(all).map(
            ([key, value]) => [value.numeric, key]
        ),
    ]);

export const dictCaseInsensitiveHtmlEntitiesToUtf8 =
    Object.fromEntries([
        ...Object.entries(all).map(
            ([key, value]) => [value.hex, key]
        ),
    ]);
